import { FC, PropsWithChildren } from 'react';
import { TemplateType } from 'constants/templateTypes';
import { useEditableFieldsContext } from '../context/EditableFieldsContext';

export const BusinessInititatedField: FC<PropsWithChildren> = ({ children }) => {
  const { liveTemplate } = useEditableFieldsContext();
  const { templateType } = liveTemplate;

  return templateType === TemplateType.BusinessInitiated ? children : null;
};

export const UserInititatedField: FC<PropsWithChildren> = ({ children }) => {
  const { liveTemplate } = useEditableFieldsContext();
  const { templateType } = liveTemplate;

  return templateType === TemplateType.UserInitiated ? children : null;
};
